// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Nauru from '../_raw/flag/icon_flag_nauru.png';

export default () => <img src={Nauru} alt="Nauru" />;
